export class Catalog
{
	toggleFav(itemId, parent)
	{
		var el = $(parent)

		if (el.hasClass("active")) var action = "del"
		else var action = "add"

		$.ajax({
			url: "/ajax.php?mid=11",
			type: "POST",
			data: {
				action: action,
				item_id: itemId,
			},
			dataType: "json",
			success: function(res) {
				if (res["success"]) {
					if (res["added"]) {
						el.addClass("active")
						//el.find("span").text("Убрать из избранного")
						//ga('send', 'event', 'fav', 'add', itemId);
					} else {
						el.removeClass("active")
						//el.find("span").text("Добавить в избранное")
						el.blur()
					}
				} else {
					alert(res["error"])
				}
			},
			error: function(err) {
				alert("Ошибка! Попробуйте повотрить запрос. Error: " + err)
			},
		})
	}

	buy(itemId)
	{
		$.ajax({
			url: "/ajax.php?mid=8",
			type: "POST",
			data: {
				action: 'buy',
				item_id: itemId,
			},
			dataType: "json",
			success: function(res) {
				if (res["success"]) {
					$(".popup-bought .text-block strong").text(res['code']);
					$(".popup-buy").removeClass("active");
					$(".popup-bought").addClass("active");

					$(".popup-bought .gift-get-text").html('<p>Ваш подарок: <strong>' + res.name + '</strong></p>' + res.instr);
					
					if (res.qr)
					{
						$(".popup-bought .gift-get-qr").show();
						$(".popup-bought .gift-get-qr img").attr('src', '/ajax.php?mid=10&action=getGiftQRcode&id=' + res.gift_id);
						$('.popup-bought .popup-qr__bar-caption').html('').hide();
					}
					else if (res.bar)
					{
						$(".popup-bought .gift-get-qr").show();
						$(".popup-bought .gift-get-qr img").attr('src', '/ajax.php?mid=10&action=getGiftBarcode&id=' + res.gift_id);
						let digits = res.code.replaceAll(/(.)/g, '<span>$1</span>');
						$('.popup-bought .popup-qr__bar-caption').html(digits).show();
					}
					else
					{
						$(".popup-bought .gift-get-qr").hide();
						$('.popup-bought .popup-qr__bar-caption').html('').hide();
					}

					if (res['balls_update'])
					{
						$('.user-nav .user-balance__value').text(res['balls_update']);
					}
				} else {
					alert(res["error"])
				}
			},
			error: function(err) {
				alert("Ошибка! Попробуйте повторить запрос. Error: " + err)
			},
		})
	}

	filter()
	{
		let form = $('.catalog-page__filter-sort');
		$.ajax({
			url: "/ajax.php?mid=8",
			type: 'POST',
			data: form.serialize() + '&action=filter',
			dataType: "html",
			success: function(html){
				$('.catalog-page__table').replaceWith(html);
			},
			error: function(err){}
		});
	}

	applyEvents()
	{
		let _this = this;
		$('.form.catalog-page__filter-sort input, .form.catalog-page__filter-sort select').change(function(){
			_this.filter();
		});
	}
}
